import { FC } from 'react';

type Win95ButtonProps = {
  title: string;
  disabled?: boolean;
  onClick: () => void;
};

const Win95Button: FC<Win95ButtonProps> = (props) => (
  <button
    className={`
      border-2 border-b-gray-500 border-l-white border-r-gray-500 border-t-white
      bg-gray-300 px-3 text-sm text-black
      active:border-b-white active:border-l-gray-500
      active:border-r-white active:border-t-gray-500
      disabled:border-gray-400 disabled:text-gray-500
      disabled:active:border-gray-400
    `}
    disabled={props.disabled}
    onClick={props.onClick}
  >
    {props.title}
  </button>
);

export default Win95Button;
